import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SHCard, isCardShowStyleList } from './lib/SHCard/SHCard';
import BottomLoading from './lib/SHCard/widgets/BottomLoading';
import Empty from './lib/SHCard/widgets/Empty';
import Request from '../../utils/request';
import utils from '../../utils/utils';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import './style.less';

const innerWidth = typeof window !== 'undefined' ? window.innerWidth : 375;
const legoBackStag = utils.getParams('isIframe') == '1';  // url参数携带isIframe=1时，表示后台预览模式
const page_id = utils.getPageId();

class PipelineGoodsRecommend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommends: [],
      hasMore: true,
      listHeight: 600,
      hasInitLoaded: false,
      showEmpty: false
    };

    this.page = 1;
    this.refreshHideTimer = null;
    this.masonry = null;
    this.MasonryClass = null;
    this.containerRef = null;
    this.scrollerViewRef = null;
    this.isLoading = false;
    this.isAndroid = utils.isAndroid();
    this.isShihuo = utils.isShihuo();
    this.baseParams = {
      recType: '',
      vcId: '',
      childCategoryId: '',
      circleGoodsId: '',
      page: this.page,
      pageSize: 10,
      page_id,
      legoBackStag
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const { categories = {}, filter_ids = [] } = this.props.config || {};
      if (categories) {
        const { dataRange, verticalIds = [], childIds = [], circleGoodsId = '', type } = categories;
        let vcId = '', childCategoryId = '', currentCircleGoodsId = '', recType = type;

        switch (dataRange) {
          case '0':
            vcId = '';
            childCategoryId = '';
            break;
          case '1':
            vcId = verticalIds.join(',');
            childCategoryId = '';
            break;
          case '2':
            vcId = '';
            childCategoryId = childIds.join(',');
            break;
          case '3':
            vcId = '';
            childCategoryId = '';
            currentCircleGoodsId = circleGoodsId;
            recType = '';
            break;
          default:
            break;
        }

        // 获取推荐信息流需要过滤的商品

        this.baseParams = {
          ...this.baseParams,
          recType,
          vcId,
          childCategoryId,
          circleGoodsId: currentCircleGoodsId,
          filter_ids 
        }
        this.getRecommendFeedsData(this.baseParams);
      }
      window.addEventListener('resize', this.updateListHeight, false);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateListHeight, false);
    }

    if (this.refreshHideTimer) {
      clearTimeout(this.refreshHideTimer);
      this.refreshHideTimer = null;
    }

    if (this.masonry) {
      this.masonry.destroy();
      this.masonry = null;
    }
  }

  // 获取推荐商品列表
  getRecommendFeedsData = async (params) => {
    const { status, data } = await this.getRecommendFeedsApi(params);
    if (status === 0) {
      const { lists = [] } = data || {};
      this.setState({
        recommends: this.page === 1 ? lists : [...this.state.recommends, ...lists],
        showEmpty: this.page === 1 && lists.length === 0,
        hasMore: lists.length > 0,
        hasInitLoaded: true,
      }, () => {
        this.page++;
        this.isLoading = false;
        if (lists.length > 0) {
          this.updateMasonryLayout(true, lists.length);
        }
      });
    }
  }

  // 推荐信息接口API获取数据
  getRecommendFeedsApi = (params) => {
    return new Promise((resolve, reject) => {
      Request({
        url: 'https://sh-gateway.shihuo.cn/v3/sh-api/daga/lego/feed/v1',
        method: "post",
        withCredentials: true,
        headers: this.isShihuo ? {
          'ptiBizMap': '1'
        } : {},
        data: params,
      }).then((res) => {
        resolve(res.data)
      }).catch(() => {
        resolve({});
      });
    });
  }

  loadMore() {
    if (this.isLoading) return;
    this.isLoading = true;
    const params = {
      ...this.baseParams,
      page: this.page,
    }
    this.getRecommendFeedsData(params);
  }

  updateMasonryLayout = (isRefreshing = false, addedCount = 0) => {
    if (!this.scrollerViewRef) {
      return;
    }

    const doLayout = () => {
      if (!this.masonry) {
        this.masonry = new this.MasonryClass(this.scrollerViewRef, {
          itemSelector: '.goods-card', // 要布局的网格元素
          fitWidth: true, // 设置网格容器宽度等于网格宽度
          gutter: 9,
          transitionDuration: 0,
        });
        if (this.scrollerViewRef) {
          this.scrollerViewRef.style.opacity = 1;
        }
      } else {
        if (isRefreshing || !addedCount) {
          this.masonry.reloadItems();
          this.masonry.layout();
        } else {
          const allItems = this.scrollerViewRef.querySelectorAll('.goods-card');
          const newElems = Array.prototype.slice.call(allItems, -addedCount);
          if (newElems && newElems.length) {
            this.masonry.appended(newElems);
          }
          this.masonry.layout();
        }
      }
    };

    if (this.MasonryClass) {
      doLayout();
      return;
    }

    import('masonry-layout').then((Masonry) => {
      this.MasonryClass = Masonry;
      doLayout();
    });
  }

  updateListHeight = () => {
    if (this.containerRef) {
      const height = this.containerRef.clientHeight;
      if (height && height !== this.state.listHeight) {
        this.setState({ listHeight: height });
      }
    } else if (typeof window !== 'undefined') {
      const height = window.innerHeight;
      if (height && height !== this.state.listHeight) {
        this.setState({ listHeight: height });
      }
    }
  }

  getTrackData(item, index) {
    const { goods_id, style_id, sku_id, goods_sku_id } = item;
    const options = {
      sort: index,
      name: item.name,
      goods_id,
      style_id,
      sku_id,
      goods_sku_id
    };
    return options;
  }

  render() {
    const { recommends, hasMore, hasInitLoaded } = this.state;
    const { isLogin, showEmpty, pageOptions = {} } = this.props;
    return (
      <div className="pipeline-goodsRecommend" ref={ref => { this.containerRef = ref; }}>
        <InfiniteScroll
          dataLength={recommends.length}
          next={this.loadMore.bind(this)}
          hasMore={hasMore}
          scrollThreshold={this.isAndroid ? 0.8 : 0.5}
          className="scroller-view"
          style={{
            width: innerWidth
          }}
          loader={hasInitLoaded ? <BottomLoading hasMore={hasMore} /> : null}
          endMessage={hasInitLoaded ? <BottomLoading hasMore={hasMore} /> : null}
        >
          <div
            ref={ref => this.scrollerViewRef = ref}
            className='scroller-container'
            style={{
              margin: showEmpty ? `0` : '0 12px'
            }}
          >
            {
              recommends && recommends.length > 0 && recommends.map((item, index) => {
                const { component, item_type, price_datas = [], v_datas = [] } = item;
                const price_label_text = price_datas.map(item => item && item.item_datas && item.item_datas[0] && item.item_datas[0].text).filter(Boolean).join(',') || '';
                const tag_label_text = v_datas.map(item => item && item.item_datas && item.item_datas[0] && item.item_datas[0].text).filter(Boolean).join(',') || '';
                const biz = {
                  goods_id: item.goods_id,
                  style_id: item.style_id,
                  sku_id: item.sku_id || item.goods_sku_id,
                  goods_sku_id: item.sku_id || item.goods_sku_id,
                  set_id: pageOptions['collectionId'],
                  type: item_type == 'COLLECTION_NOTE_CARD' ? 'note' : 'goods',
                  component,
                  price_label_text,
                  tag_label_text,
                  model_block: 'recommend-feeds-card'
                }
                const h5_exposure_object = {
                  id: `${this.props.templatePti}:recommend-feeds:${index + 1}`,
                  name: '',
                  href: item.href,
                  pageOptions: {
                    ...pageOptions,
                    ...biz
                  },
                  biz: JSON.stringify({
                    ...pageOptions,
                    ...biz
                  }),
                  exposekey: `${this.props.templatePti}:recommend-feeds:${index + 1}`,
                  exposekey_self: item.expose_key || '',
                };
                return (
                  <div
                    key={`list-${index + 1}`}
                    style={{
                      position: 'relative'
                    }}
                  >
                    <SHCard
                      key={`list-${index + 1}-${item.goods_id}`}
                      type={component}
                      isDark={false}
                      isLogin={isLogin}
                      dataSource={item}
                      h5_exposure_object={h5_exposure_object}
                      exp={this.props.exp}
                      onPress={() => {
                        let ptiID = `${this.props.templatePti}:recommend-feeds:${index + 1}`
                        // if (isCardShowStyleList(item)) {
                        //   ptiID = `${this.props.templatePti}:recommend-feeds:${index + 1}_0`
                        // }
                        const ptiOptions = {
                          ptiId: ptiID,
                          ptiName: '',
                          bizExtra: {
                            ...pageOptions,
                            ...biz
                          }
                        }
                        const options = this.getTrackData(item, index);
                        const convertUrl = utils.convertHref(item.href);
                        utils.jumpToUrl(this.props.routeParams, convertUrl, convertUrl, options, -1, this.props, false, ptiOptions);
                      }}
                    />
                  </div>
                )
              })
            }
            {showEmpty && <Empty />}
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}

export default PipelineGoodsRecommend;



// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/index.jsx